export const CHART_COLORS = {
  profit: '#00B68F',
  profitSubtle: 'rgba(0, 182, 143, 0.1)',
  loss: '#DF484C',
  lossSubtle: 'rgba(223, 72, 76, 0.14)',
  lossFaint: 'rgba(223, 72, 76, 0.45)',
  overlayVwap: '#7C3AED',
  overlayTwap: '#F59E0B',
  overlayVolatility: '#06B6D4',
  overlayLiquidationPrice: '#D946EF',
  overlayBuyVolume: '#3B82F6',
  overlaySellVolume: '#8B5CF6',
  profileBuy: 'rgba(41, 98, 255, 0.55)',
  profileSell: 'rgba(242, 201, 76, 0.55)',
  neutral: '#7f839a',
  positionLabelBackground: '#3F4354',
  transparent: 'rgba(255, 255, 255, 0)',
  // Match the chart toolbar's secondary button text (`text-foreground/60`).
  // TradingView paints axis labels on canvas, so these cannot use CSS variables directly.
  scaleText: 'rgba(12, 12, 13, 0.6)',
  darkScaleText: 'rgba(255, 255, 255, 0.6)',
  // Line / Area series (Tick draws as Area): the foreground, fading to nothing below it,
  // instead of TradingView's default blue — the one series style that isn't up/down.
  seriesLine: 'rgba(12, 12, 13, 0.9)',
  seriesFillTop: 'rgba(12, 12, 13, 0.1)',
  seriesFillBottom: 'rgba(12, 12, 13, 0)',
  darkSeriesLine: 'rgba(255, 255, 255, 0.9)',
  darkSeriesFillTop: 'rgba(255, 255, 255, 0.1)',
  darkSeriesFillBottom: 'rgba(255, 255, 255, 0)',
  darkAxisHighlight: '#242526',
  quantityText: '#0C0C0D',
  markLabel: '#FFFFFF',
} as const

// High-contrast categorical colors for native TradingView Compare studies.
// Keep adjacent entries separated in hue so several overlapping percentage
// series and their price-scale labels remain distinguishable in both themes.
export const COMPARE_SERIES_PALETTE = [
  '#2962FF',
  '#F59E0B',
  '#7C3AED',
  '#00A884',
  '#E53935',
  '#00ACC1',
  '#EC407A',
  '#6D4C41',
] as const

export function getCompareSeriesColor(index: number) {
  return COMPARE_SERIES_PALETTE[index % COMPARE_SERIES_PALETTE.length]
}

// One positive/negative color pair per profile-lane kind, so overlapping lanes (e.g.
// Liquidation Levels + Stop Levels shown together) read as distinct series rather than all
// looking like the same blue/yellow bars. `volume`/`liquidation`/`openInterest` keep the
// original profileBuy/profileSell pair (already shipped, unchanged); the newer Hyperliquid
// liquidation/stop-level lanes get their own hues. Alpha matches profileBuy/profileSell (0.55)
// so bar opacity stays consistent across every lane.
export const PROFILE_LANE_COLORS = {
  volume: { positive: CHART_COLORS.profileBuy, negative: CHART_COLORS.profileSell },
  liquidation: { positive: CHART_COLORS.profileBuy, negative: CHART_COLORS.profileSell },
  openInterest: { positive: 'rgba(6, 182, 212, 0.55)', negative: 'rgba(245, 158, 11, 0.55)' },
  liquidationLevels: { positive: 'rgba(124, 58, 237, 0.55)', negative: 'rgba(217, 70, 239, 0.55)' },
  stopLevels: { positive: 'rgba(20, 184, 166, 0.55)', negative: 'rgba(236, 72, 153, 0.55)' },
} as const

export const MAIN_PANE_VOLUME_MAX_HEIGHT_RATIO = 0.3

export function getMainPaneVolumeScaleCeiling(value: number) {
  return Math.abs(value) / MAIN_PANE_VOLUME_MAX_HEIGHT_RATIO
}
